var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isHavePermission)?_c('el-button',{attrs:{"type":_vm.type,"icon":_vm.icon,"size":_vm.size}},[_vm._v(_vm._s(_vm.name))]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }